var u = navigator.userAgent;
var biliVersion = (u.match(/BiliApp\/([^ ]*)/) || [])[1] || '0';
export var isBlackBerry = /BlackBerry/i.test(u);
export var isWindowPhone = /IEMobile/i.test(u);
export var isAndroid = /android|adr|linux/gi.test(u);
export var isQQ = /QQ\/([\d.]+)/.test(u);
export var isWechat = /MicroMessenger/i.test(u);
export var isiOS = /iPad|iPhone|iPod/.test(u);
export var isIpad = /iPad/.test(u) || /(iPad).*OS\s([\d_]+)/i.test(u);
export var isPad = /PAD|pad/i.test(u);
export var isIE = !!window.ActiveXObject || 'ActiveXObject' in window;
export var isMobile = isiOS || isAndroid || isBlackBerry || isWindowPhone;
export var isBiliApp = (/BiliApp|BiliComic/i).test(u);
export var isApp = u.indexOf("Bili") > -1;
export var isUat = window.location.href.indexOf("uat") >= 0;
export var isPreview = window.location.href.indexOf("preview") > -1;
export var isIphone = /(iPhone\sOS)\s([\d_]+)/i.test(u);
export var isIpod = /(iPod)(.*OS\s([\d_]+))?/i.test(u);
export var isApple = isIphone || isIpad || isIpod;
export var isPC = (function () {
    var agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad'];
    var isPC = true;
    for (var i = 0, len = agents.length; i < len; i++) {
        if (u.indexOf(agents[i]) > 0) {
            isPC = false;
            break;
        }
    }
    return isPC;
})();
export var getBiliAppVersion = function () {
    var v = u.match(/\d+$/);
    var version;
    if (isBiliApp && v && Array.isArray(v) && v.length > 0) {
        version = v[1];
    }
    return version;
};
export var BILI_VERSION = biliVersion.length > 4
    ? Number(biliVersion.toString().substr(0, 4))
    : Number(biliVersion);
//# sourceMappingURL=detector.js.map